import {
  FETCHSENSORS_SUCCESS,
  FETCHNFCTAGS_SUCCESS,
  FETCHNFCTAGSCONNECTION_SUCCESS,
  FETCHLIGHTINGS_SUCCESS,
  FETCHIBEACONS_SUCCESS,
  FETCHEDDYSTONES_SUCCESS,
  FETCHREADERS_SUCCESS,
  FETCHHUBS_SUCCESS,
  FETCHGATEWAYS_SUCCESS,
  FETCHIBEACON_SUCCESS,
  FETCHEDDYSTONE_SUCCESS,
  FETCHREADER_SUCCESS,
  FETCHHUB_SUCCESS,
  FETCHGATEWAY_SUCCESS,
  FETCHMODELS_SUCCESS,
  CREATEDEVICE_SUCCESS,
  CREATEIBEACON_SUCCESS,
  CREATEEDDYSTONE_SUCCESS,
  CREATEREADER_SUCCESS,
  CREATEHUB_SUCCESS,
  CREATEGATEWAY_SUCCESS,
  UPDATEDEVICE_SUCCESS,
  UPDATEIBEACON_SUCCESS,
  UPDATEEDDYSTONE_SUCCESS,
  UPDATEREADER_SUCCESS,
  UPDATEHUB_SUCCESS,
  UPDATEGATEWAY_SUCCESS,
  DELETEDEVICE_SUCCESS,
  DELETEIBEACON_SUCCESS,
  DELETEEDDYSTONE_SUCCESS,
  DELETEREADER_SUCCESS,
  DELETEHUB_SUCCESS,
  DELETEGATEWAY_SUCCESS,
  CREATEDEVICES_SUCCESS,
  CREATEDEVICESPARALLEL_SUCCESS,
  DELETEDEVICES_SUCCESS,
  VALIDATEDEVICES_SUCCESS,
  UPDATESHADOW_SUCCESS,
  OTAUPDATE_SUCCESS,
  FETCHDEVICELOGS_SUCCESS,
  CREATEMESHELEMENT_SUCCESS,
  UPDATEMESHELEMENT_SUCCESS,
  DELETEMESHELEMENT_SUCCESS,
  FETCHWIFITESTS_SUCCESS,
  OPENBUZZVOXLOCK_SUCCESS,
  COUNTNFCTAGSLATLNG_SUCCESS,
  COUNTSERIALRANGE_SUCCESS,
  GETSERIALRANGE_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
  iBeacons: {},
  eddystones: {},
  readers: {},
  hubs: {},
  gateways: {},
  sensors: {},
  nfcTags: {},
  nfcTagsFiltered: {},
  nfcTagsCursorIndex: {},
  lightings: {},
  models: [],
  deleted: false,
  deletedDevices: false,
  updatedShadow: false,
  deviceLogs: {},
  deviceMap: {},
  wifiTests: {},
  createdDevicesParallel: {},
  latLngCount: {},
  serialRangeCount: {},
  serialRange: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCHSENSORS_SUCCESS: {
      return {
        ...state,
        sensors: {
          [action.applicationId || 'inventory']: action.payload.getSensorsWithIoT
        }
      }
    }

    case FETCHNFCTAGS_SUCCESS: {
      return {
        ...state,
        nfcTags: {
          ...state.nrfTags,
          [action.applicationId || 'inventory']: action.payload.getNFCTagsWithIoT
        }
      }
    }

    case COUNTSERIALRANGE_SUCCESS: {
      return {
        ...state,
        serialRangeCount: {
          ...state.serialRangeCount,
          [action.serialRangeStart + ":" + action.serialRangeEnd]: action.payload.count
        }
      }
    }

    case GETSERIALRANGE_SUCCESS: {
      console.log('GETSERIALRANGE_SUCCESS', action);
      return {
        ...state,
        serialRange: {
          ...state.serialRange,
          [action.applicationId || 'inventory']: action.payload
        }
      }
    }

    case COUNTNFCTAGSLATLNG_SUCCESS: {
      const type = action.models ? 'nfcTag': 'all';
      return {
        ...state,
        latLngCount: {
          ...state.latLngCount,
          [action.applicationId || 'inventory']: {
            ...state.latLngCount[action.applicationId || 'inventory'],
            [type]: action.payload.countNFCTagsByLatLng
          }
        }
      }
    }

    case FETCHNFCTAGSCONNECTION_SUCCESS: {
      console.log('FETCHNFCTAGSCONNECTION_SUCCESS', action);
      const {before, after, first, last, models, searchTerm, searchParam, applicationId} = action;
      const key = JSON.stringify({
        applicationId: (applicationId || 'inventory'), models, searchParam, searchTerm
      });

      console.log('key', key);

      let newNFCTags, newNFCTagsCursorIndex;

      if (first) {
        let startIndex = 0;
        if (after && state.nfcTagsCursorIndex[key]) {
          startIndex = ((state.nfcTagsCursorIndex[key] || {})[after] || - 1) + 1
        }

        console.log('startIndex', startIndex);

        const newCursors = {};
        action.payload.edges.forEach((e,i) => {
          newCursors[e.cursor] = startIndex + i;
        });

        console.log('newCursors', newCursors);

        newNFCTags = {
          ...state.nfcTags,
          [key]:
          [...Array(action.payload.totalCount).keys()].map((index) => {
            if (index >= startIndex && index < startIndex + first) {
              return {
                ...action.payload.edges[index - startIndex].node,
                cursor: action.payload.edges[index - startIndex].cursor
              }
            } else {
              return (state.nfcTags[key] || {})[index] || {}
            }
          })
        };

        newNFCTagsCursorIndex = {
          [key]: {
            ...state.nfcTags[key],
            ...newCursors
          }
        };

        console.log('newNFCTags', newNFCTags);
        console.log('newNFCTagsCursorIndex', newNFCTagsCursorIndex);
      } else {
        let endIndex = action.payload.totalCount;
        if (before && state.nfcTagsCursorIndex[key]) {
          endIndex = ((state.nfcTagsCursorIndex[key] || {})[before] || - 1) - 1
        }

        console.log('endIndex', endIndex);

        const newCursors = {};
        action.payload.edges.forEach((e,i) => {
          newCursors[e.cursor] = endIndex - i;
        });

        console.log('newCursors', newCursors);

        newNFCTags = {
          ...state.nfcTags,
          [key]:
          [...Array(action.payload.totalCount).keys()].map((index) => {
            if (index <= endIndex && index > endIndex - last) {
              return {
                ...action.payload.edges[endIndex - index].node,
                cursor: action.payload.edges[endIndex - index].cursor
              }
            } else {
              return (state.nfcTags[key] || {})[index] || {}
            }
          })
        };

        newNFCTagsCursorIndex = {
          [action.applicationId || 'inventory']: {
            ...state.nfcTags[key],
            ...newCursors
          }
        };

        console.log('newNFCTags', newNFCTags);
        console.log('newNFCTagsCursorIndex', newNFCTagsCursorIndex);
      }

      return {
        ...state,
        nfcTags: newNFCTags,
        nfcTagsCursorIndex: newNFCTagsCursorIndex
      }
    }

    case FETCHLIGHTINGS_SUCCESS: {
      return {
        ...state,
        lightings: {
          [action.applicationId || 'inventory']: action.payload.getLightingsWithIoT
        }
      }
    }

    case FETCHIBEACONS_SUCCESS: {
      return {
        ...state,
        iBeacons: {
          [action.applicationId || 'inventory']: action.payload.getIBeaconsWithIoT
        }
      }
    }

    case FETCHEDDYSTONES_SUCCESS: {
      return {
        ...state,
        eddystones: {
          [action.applicationId || 'inventory']: action.payload.getEddystones
        }
      }
    }

    case FETCHREADERS_SUCCESS: {
      return {
        ...state,
        readers: {
          [action.applicationId || 'inventory']: action.payload.getReadersWithIoT
        }
      }
    }

    case FETCHHUBS_SUCCESS: {
      return {
        ...state,
        hubs: {
          [action.applicationId || 'inventory']: action.payload.getBluetoothHubs
        }
      }
    }

    case FETCHGATEWAYS_SUCCESS: {
      return {
        ...state,
        gateways: {
          [action.applicationId || 'inventory']: action.payload.getGateways
        }
      }
    }


    case FETCHIBEACON_SUCCESS: {
      return {
        ...state,
        iBeacon: {
          ...state.iBeacon,
          [action.deviceId]: action.payload.getIBeacon
        },
        deviceMap: {
          ...state.deviceMap,
          [action.deviceId]: action.payload.getIBeacon
        }
      }
    }

    case FETCHEDDYSTONE_SUCCESS: {
      return {
        ...state,
        eddystone: {
          ...state.eddystone,
          [action.deviceId]: action.payload.getEddystone
        },
        deviceMap: {
          ...state.deviceMap,
          [action.deviceId]: action.payload.getEddystone
        }
      }
    }

    case FETCHREADER_SUCCESS: {
      return {
        ...state,
        reader: {
          ...state.reader,
          [action.deviceId]: action.payload.getReader
        },
        deviceMap: {
          ...state.deviceMap,
          [action.deviceId]: action.payload.getReader
        }
      }
    }

    case FETCHHUB_SUCCESS: {
      return {
        ...state,
        hub: {
          ...state.hub,
          [action.deviceId]: action.payload.getBluetoothHub
        },
        deviceMap: {
          ...state.deviceMap,
          [action.deviceId]: action.payload.getBluetoothHub
        }
      }
    }

    case FETCHGATEWAY_SUCCESS: {
      console.log('action.deviceId', action.deviceId);
      console.log('action.payload', action.payload);
      return {
        ...state,
        gateway: {
          ...state.gateway,
          [action.deviceId]: action.payload.getGateway
        },
        deviceMap: {
          ...state.deviceMap,
          [action.deviceId]: action.payload.getGateway
        }
      }
    }

    case FETCHMODELS_SUCCESS: {
      return {
        ...state,
        models: action.payload.getModels
      }
    }

    case CREATEDEVICE_SUCCESS: {
      return {
        ...state,
        createdDevice: action.payload,
        loader: false
      }
    }

    case CREATEIBEACON_SUCCESS: {
      return {
        ...state,
        createdDevice: action.payload,
        loader: false
      }
    }

    case CREATEEDDYSTONE_SUCCESS: {

      return {
        ...state,
        createdDevice: action.payload,
        loader: false
      }
    }

    case CREATEREADER_SUCCESS: {

      return {
        ...state,
        createdDevice: action.payload,
        loader: false
      }
    }

    case CREATEHUB_SUCCESS: {

      return {
        ...state,
        createdDevice: action.payload,
        loader: false
      }
    }

    case CREATEGATEWAY_SUCCESS: {

      return {
        ...state,
        createdDevice: action.payload,
        loader: false
      }
    }

    case UPDATEDEVICE_SUCCESS: {
      console.log('action.payload', action.payload);

      return {
        ...state,
        updatedDevice: action.payload.updateDevice,
        loader: false
      }
    }

    case UPDATEIBEACON_SUCCESS: {
      console.log('action.payload', action.payload);

      return {
        ...state,
        updatedDevice: action.payload.updateIBeacon,
        loader: false
      }
    }

    case UPDATEEDDYSTONE_SUCCESS: {

      return {
        ...state,
        updatedDevice: action.payload.updateEddystone,
        loader: false
      }
    }

    case UPDATEREADER_SUCCESS: {

      return {
        ...state,
        updatedDevice: action.payload.updateReader,
        loader: false
      }
    }

    case UPDATEHUB_SUCCESS: {

      return {
        ...state,
        updatedDevice: action.payload.updateBluetoothHub,
        loader: false
      }
    }

    case UPDATEGATEWAY_SUCCESS: {

      return {
        ...state,
        updatedDevice: action.payload.updateGateway,
        loader: false
      }
    }

    case DELETEDEVICE_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    case DELETEIBEACON_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    case DELETEEDDYSTONE_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    case DELETEREADER_SUCCESS: {

      return {
        ...state,
        deleted: action.payload
      }
    }

    case DELETEHUB_SUCCESS: {

      return {
        ...state,
        deleted: action.payload
      }
    }

    case DELETEGATEWAY_SUCCESS: {

      return {
        ...state,
        deleted: action.payload
      }
    }

    case CREATEDEVICES_SUCCESS: {
      console.log('createdDevices', action.payload);
      console.log('action.index', action.index);

      if (!action.index && action.index !== 0) {
        return {
          ...state,
          createdDevices: action.payload.createDevices,
        }
      } else {
        console.log('this.state.createdDevicesParallel',
        state.createdDevicesParallel);
        return {
          ...state,
          createdDevicesParallel:  {
            ...state.createdDevicesParallel,
            [action.index]: action.payload
          }
        }
      }
    }

    case CREATEDEVICESPARALLEL_SUCCESS: {
      console.log('this.state.createdDevicesParallel',
      state.createdDevicesParallel);
      return {
        ...state,
        createdDevicesParallel:  {
          ...state.createdDevicesParallel,
          [action.index]: action.payload.createdDevices
        }
      }
    }

    case DELETEDEVICES_SUCCESS: {

      return {
        ...state,
        deletedDevices: action.payload
      }
    }

    case VALIDATEDEVICES_SUCCESS: {
      console.log('VALIDATEDEVICES_SUCCESS', action.payload);
      return {
        ...state,
        validatedDevices: action.payload
      }
    }

    case UPDATESHADOW_SUCCESS: {
      return {
        ...state,
        updatedShadow: action.payload.updateShadow,
      }
    }

    case OTAUPDATE_SUCCESS: {
      console.log('OTAUPDATE_SUCCESS',
    action.payload.otaUpdate);
      return {
        ...state,
        otaUpdated: action.payload.otaUpdate,
      }
    }

    case FETCHDEVICELOGS_SUCCESS: {
      return {
        ...state,
        deviceLogs: {
          [action.deviceId]: action.payload.getDeviceLogs
        }
      }
    }

    case CREATEMESHELEMENT_SUCCESS: {

      return {
        ...state,
        createdElement: action.payload,
        loader: false
      }
    }

    case UPDATEMESHELEMENT_SUCCESS: {

      return {
        ...state,
        updatedElement: action.payload,
        loader: false
      }
    }

    case DELETEMESHELEMENT_SUCCESS: {

      return {
        ...state,
        deletedElement: action.payload
      }
    }

    case FETCHWIFITESTS_SUCCESS: {
      console.log('FETCHWIFITESTS_SUCCESS',
      action.applicationId, action.payload)
      return {
        ...state,
        wifiTests: {
          [action.applicationId]: action.payload.getWifiTests
        }
      }
    }

    case OPENBUZZVOXLOCK_SUCCESS: {
      return {
        ...state,
        openBuzzVoxLockJob: action.payload.openBuzzVoxLock,
      }
    }

    default:
      return {
        ...state,
        createdDevice: false,
        updatedDevice: false,
        deleted: false,
        createdDevices: false,
        deletedDevices: false,
        validatedDevices: false,
        updatedShadow: false,
        otaUpdated: false,
        createdElement: false,
        updatedElement: false,
        deletedElement: false,
        openBuzzVoxLockJob: false
      }
  }
}
